'use client'

import { useMemo, useState } from 'react'

import { Button, Icon } from '@graftcode/design-system'

import { useGatewayUserSettings } from '@/core/hooks/useGatewayUserSettings'
import { getGatewayConfig } from '@/core/utils/gateway'

import { GatewaySettingsDialog } from './GatewaySettingsDialog'

import styles from './GatewayConnectionSettings.module.scss'

interface GatewayConnectionSettingsProps {
  onRefetchGateway: () => Promise<unknown>
  variant?: 'icon' | 'button'
}

export function GatewayConnectionSettings({ onRefetchGateway, variant = 'icon' }: GatewayConnectionSettingsProps) {
  const [open, setOpen] = useState(false)
  const { host, port, isSecured } = getGatewayConfig()
  const baseConfig = useMemo(() => ({ host, port, isSecured }), [host, port, isSecured])
  const { gatewaySettings, applyGatewaySettings, resetGatewaySettings } = useGatewayUserSettings()

  return (
    <>
      {variant === 'icon' ? (
        <Button
          iconOnly
          icon={Icon.SettingsRegular}
          variant="ghost"
          size="s"
          className={styles.iconButton}
          onClick={() => setOpen(true)}
          aria-label="Configure gateway connection"
          title="Configure gateway connection"
        />
      ) : (
        <Button
          text="Connection settings"
          icon={Icon.SettingsRegular}
          variant="outlined"
          size="s"
          onClick={() => setOpen(true)}
        />
      )}

      <GatewaySettingsDialog
        open={open}
        onOpenChange={setOpen}
        gatewaySettings={gatewaySettings}
        baseConfig={baseConfig}
        applyGatewaySettings={applyGatewaySettings}
        resetGatewaySettings={resetGatewaySettings}
        onRefetchGateway={onRefetchGateway}
      />
    </>
  )
}
